import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { PAEmailMultipleRequest } from "./pa-email-multiple-request";
import { PersonRegisteredUsersRequest } from "./person-registered-users-request";
import { RegPersonToggleRequest } from "./reg-person-toggle-request";

@Injectable()
export class DataService_Parent_PortalAppReg {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	PortalAppStudentGuardianSelectList(PersonID) {
		var postResult$ = new Subject();
		var url = "PortalApps/PortalAppStudentGuardianSelectList?PersonID=" + PersonID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	PortalAppQRCodeEmailMultiple(parms: PAEmailMultipleRequest) {
		var postResult$ = new Subject();
		var url = "PortalApps/PortalAppQRCodeEmailMultiple";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	PersonRegisteredUsersSelectList(parms: PersonRegisteredUsersRequest) {
		var postResult$ = new Subject();
		var url = "PortalApps/PersonRegisteredUsersSelectList";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	RegPersonToggle(parms: RegPersonToggleRequest) {
		var postResult$ = new Subject();
		var url = "PortalApps/RegPersonToggle";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
